<template>
  <div class="card-body py-3" v-if="!isLoaded || !isEmpty(organisation.highlights.technologies)">
    <div class="d-flex justify-content-between">
      <h3 class="mb-0 t-md t-400">
        Technologies
      </h3>
      <i class="fa fa-lightbulb-o t-secondary t-lr" />
    </div>
    <template  v-if="isLoaded">
      <div v-for="(technology, index) in organisation.highlights.technologies" :key="technology.title">
        <h3 class="mt-3 t-600">{{ technology.title }}</h3>
        <long-text v-if="technology.description" :text="technology.description" :truncateAt="500" :isRichText="true" class="mt-3" />
        <hr v-if="index + 1 < organisation.technologies.length"/>
      </div>
    </template>
    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import LongText from '@/components/shared/LongText'

export default {
  name: 'organisationTechnologies',
  components: {
    Spinner,
    LongText
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    organisation: {
      type: Object,
      required: true
    }
  }
}
</script>
